module.exports = __webpack_public_path__ + "static/media/list-music.78b9e9c1.svg";